import * as React from "react";
import { Button } from "@mui/material";
import { BorrowerChild } from "../LinkedAccountsPage";
import { useLanguage } from "@tlc/ls2pac/components/Language";
import { ChildSelectionDialog } from "./ChildSelectionDialog";

interface AssociatedStudentsProps {
  listId: number;
  children: BorrowerChild[];
  childIds: BorrowerChild["id"][];
}

export const AssociatedStudents: React.FC<AssociatedStudentsProps> = ({
  childIds: initialChildIds,
  children,
  listId,
}) => {
  const { translate } = useLanguage();
  const [isChildSelectionOpen, setChildSelectionOpen] =
    React.useState<boolean>(false);
  const [childIds, setChildIds] = React.useState(initialChildIds || []);

  const associatedStudents = React.useMemo(() => {
    const childNames = children
      .filter((child) => childIds.includes(child.id))
      .map((child) => `${child.firstName} ${child.lastName}`)
      .sort();
    if (childNames.length === 0) {
      return "None"; // TODO translate
    }

    if (childNames.length === 1) {
      return childNames[0];
    }

    if (childNames.length === 2) {
      return childNames.join(" and "); // TODO translate
    }

    return `${childNames.slice(0, -1).join(", ")}, and ${
      childNames[childIds.length - 1]
    }`;
  }, [childIds]);

  return (
    <>
      {translate("associatedStudents")}: {associatedStudents}
      <Button onClick={() => setChildSelectionOpen(true)}>
        {translate("edit")}
      </Button>
      <ChildSelectionDialog
        open={isChildSelectionOpen}
        onClose={() => setChildSelectionOpen(false)}
        onSave={(updatedChildIds) => {
          setChildSelectionOpen(false);
          setChildIds(updatedChildIds);
        }}
        children={children}
        listId={listId}
        childIds={childIds}
      ></ChildSelectionDialog>
    </>
  );
};
